import type { Version } from "../../lib/changelogParser";
import { formatDate } from "../../lib/changelogParser";
import { ChangeSection } from "./ChangeSection";
import { VersionBadge } from "./VersionBadge";

interface VersionEntryProps {
  version: Version;
}

export function VersionEntry({ version }: VersionEntryProps) {
  const anchorId = `v${version.version.replace(/\./g, "-")}`;

  return (
    <article
      id={anchorId}
      className="scroll-mt-20 border-b border-dark-border pb-8 last:border-b-0"
    >
      <div className="flex items-center gap-3 mb-4">
        <h2 className="text-2xl font-bold text-warm-50">{version.version}</h2>
        <VersionBadge isLatest={version.isLatest} />
      </div>

      <time className="block text-warm-500 text-sm mb-6">{formatDate(version.date)}</time>

      <div className="space-y-4">
        {version.sections.map((section, index) => (
          <ChangeSection key={index} section={section} />
        ))}
      </div>
    </article>
  );
}
